import React from 'react';
import { CMSMenu } from "../toolympus/components/CMS";
import { PowerEditorSettingsProvider } from '../toolympus/components/PowerDoc/PowerEditorSettingsContext';
import { useMediaFilesPlugin } from '../toolympus/components/PowerDoc/plugins/MediaFiles';
import { PowerEditorBase, PowerEditorBaseProps } from '../toolympus/components/PowerDoc';
import { ColumnsPlugin } from '../toolympus/components/PowerDoc/plugins/Columns';
import { CustomFieldsBlockPlugin } from '../toolympus/components/PowerDoc/plugins/CustomFieldsBlock';
import { ExpanderPlugin } from '../toolympus/components/PowerDoc/plugins/Expander';
import { PanelPlugin } from '../toolympus/components/PowerDoc/plugins/Panel/PanelPlugin';
import { ScriptPlugin } from '../toolympus/components/PowerDoc/plugins/Script';
import { TablesPlugin } from '../toolympus/components/PowerDoc/plugins/Tables';
import { TilesPlugin } from '../toolympus/components/PowerDoc/plugins/Tiles';
import { useLinkedRecordsEditorPlugin } from '../toolympus/components/CMS';
import { useSub } from './SubProvider';
import { MedialibProviderX } from './Medialib';
import { LoadingIndicator } from '../toolympus/components/primitives';
import { useBlockImagesPlugin } from '../toolympus/components/PowerDoc/plugins/InlineImages';
import { useTextClassPlugin } from '../toolympus/components/PowerDoc/plugins/BasicCommands/useTextClassPlugin';
import { ButtonBlockPlugin } from '../toolympus/components/PowerDoc/plugins/ButtonBlockPlugin';
import { ICMSConfiguration } from '../toolympus/components/CMS/Configuration/CMSConfigurationContext';
import { ConfigurableTableBlockPlugin } from '../toolympus/components/PowerDoc/plugins/ConfigurableTableBlock';
import { usePreconfiguredBlocksPlugin } from '../toolympus/components/PowerDoc/plugins/PreconfiguredBlocksPlugin';


export const SiteBaseUrl = "https://riac.centerarbitr.ru";

const CMSConfiguration: Partial<ICMSConfiguration> = {
  getSiteUrl: (record) => record
    ? `${SiteBaseUrl}/open?lang=${record.lang}&entity=${record.record_type}&slugOrId=${record.slug}`
    : SiteBaseUrl,
}

export const CMS = () => {
  const { sub } = useSub();
  return (
    <MedialibProviderX>
      <PowerEditorSettingsProvider
          EditorComponent={CMSEditorUnwrapped}>
          {sub
            ? <CMSMenu
                apiPath={`/api/${sub}/cms/`}
                includeMediaLib
                configuration={CMSConfiguration}
                />
            : <LoadingIndicator />}

      </PowerEditorSettingsProvider>      
    </MedialibProviderX>
  );
}


export const CMSEditorUnwrapped = (props: PowerEditorBaseProps) => {
  const mediaFilesPlugin = useMediaFilesPlugin();
  const linkedRecordsPlugin = useLinkedRecordsEditorPlugin();
  const blockImagePlugin = useBlockImagesPlugin();
  const textClassPlugin = useTextClassPlugin();
  const preconfiguredBlocksPlugin = usePreconfiguredBlocksPlugin();

  return (
      <PowerEditorBase
          {...props}
          plugins={[
              mediaFilesPlugin,
              blockImagePlugin,
              ButtonBlockPlugin,
              CustomFieldsBlockPlugin,
              ConfigurableTableBlockPlugin,
              preconfiguredBlocksPlugin,
              TilesPlugin,
              ColumnsPlugin,
              PanelPlugin,
              ScriptPlugin,
              ExpanderPlugin,
              TablesPlugin,
              linkedRecordsPlugin,
              textClassPlugin,
          ]}
          />
  );
}
